export enum ItemClass {
    Consumable = 0,
    Container = 1,
    Weapon = 2,
    Gem = 3,
    Armor = 4,
    Reagent = 5,
    Projectile = 6,
    Tradeskill = 7,
    ItemEnhancement = 8,
    Recipe = 9,
    // Money(OBSOLETE) = 10
    Quiver = 11,
    Quest = 12,
    Key = 13,
    // Permanent(OBSOLOTE) = 14
    Misc = 15,
    Glyph = 16,
    BattlePet = 17,
    WowToken = 18,
    Profession = 19,
}
